export default __webpack_public_path__ + "static/media/petal_CognitiveHealth.d288a96c.svg";